import React, { useState, useRef, useEffect } from "react";
import "./SearchSelect.css";
import { ReactComponent as ChevronDown } from "../assets/icons/chevron-down.svg";
import { ReactComponent as Search } from "../assets/icons/search.svg";

export default function SelectSearch({
  placeholder,
  value,
  setValue,
  list = [],
  withoutSearch = false,
  disabled = false,
  activeDropdown, // Track which dropdown is active
  setActiveDropdown, // Function to update active dropdown
  dropdownId, // Unique ID for this dropdown
}) {
  const ref1 = useRef(null);
  const isActive = activeDropdown === dropdownId;
  const [searchItem, setSearchItem] = useState(""); // Search input value
  const [label, setLabel] = useState(""); // Selected item's label

  // Update label when value changes
  useEffect(() => {
    const selectedItem = list.find((item) => item.value === value);
    setLabel(selectedItem ? selectedItem.label : "");
  }, [value, list]);

  // Function to toggle dropdown
  const toggleDropdown = () => {
    if (!disabled) {
      setActiveDropdown(isActive ? null : dropdownId); // Close if already open, otherwise open
    }
  };

  return (
    <div
      className={`servicesSelectOrdercontainer ${disabled ? "disabled" : ""}`}
    >
      <input
        onClick={toggleDropdown}
        readOnly
        className={`servicesSelectOrder ${
          value ? "servicesSelectNotEmpty" : ""
        } ${isActive ? "servicesSelectOrderOpened" : ""}`}
        value={label} // Show the label in the input
        disabled={disabled} // Disable input if needed
      />
      <span
        className={`servivesElectPlaceholder ${
          value ? "servicesSelectPlaceholderFocus" : ""
        }`}
      >
        {placeholder}
      </span>
      <ChevronDown
        onClick={toggleDropdown}
        className={`servicesChevronDown ${
          isActive ? "servicesChevronFocused" : ""
        } ${disabled ? "servicesChevronDisabled" : ""}`}
      />

      {isActive && (
        <div ref={ref1} className="translationLanguageOptions">
          {!withoutSearch && list.length !== 0 && (
            <div className="languageSearchForm">
              <input
                autoFocus
                value={searchItem}
                onChange={(e) => setSearchItem(e.target.value)}
                placeholder="Search"
                className="languageSearchFormsInput"
                disabled={disabled || list.length === 0}
              />
              <Search className="languageSearchFormIcon" />
            </div>
          )}
          <div className="countryListContainer">
            {list.length === 0 ? (
              <div className="text-center">No options found</div>
            ) : (
              list
                .filter((item) =>
                  item.label.toLowerCase().includes(searchItem.toLowerCase())
                )
                .map((item, i) => (
                  <div
                    key={i}
                    className="languageWrapper"
                    onClick={() => {
                      setValue(item.value); // Update selected item
                      setActiveDropdown(null); // Close dropdown
                      setSearchItem(""); // Clear search
                    }}
                  >
                    <div
                      className={`translationLanguageOption ${
                        item.value === value ? "highlighted" : ""
                      }`}
                    >
                      {item.label}
                    </div>
                  </div>
                ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
